
import { useState } from 'react';
import ExpensesList from './ExpensesList';
import Card from '../UI/Card';
import ExpensesFilter from './ExpensesFilter';
import ExpensesChart from './ExpensesChart';
import './Expense.css';

const Expense = (props) => {
const [filteredYear, setFilteredYear] = useState('')

const filterChangeHandler = (selectedYear) => {
  setFilteredYear(selectedYear)
}

const filteredExpenses = props.items.filter(expense => {
  return expense.date.getFullYear().toString() === filteredYear
})

  return (
    <div>
    <Card className="expenses">
      <ExpensesFilter 
      selected={filteredYear} 
      onChangeFilter={filterChangeHandler} 
      />
      <ExpensesChart expenses = {filteredExpenses}/>
      <ExpensesList items = {filteredExpenses} />
    </Card>
    </div>
  ) 
}

export default Expense;
